export default {
    get(key) {
        try {
            const raw = sessionStorage.getItem(key);
            return raw ? JSON.parse(raw) : null;
        } catch(e) {
            return null;
        }
    },

    set(key, value) {
        try {
            sessionStorage.setItem(key, JSON.stringify(value));
        } catch(e) {}
    },

    remove(key) {
        try {
            sessionStorage.removeItem(key);
        } catch(e) {}
    }
};
